var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBedSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 55,
    viewBox: "0 0 87 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.1952V26.7324V10.7471C1.40613 8.91949 4.65517 5.87353 11.9655 5.87353C12.3716 4.24902 13.9149 1 16.8391 1H64.7042C65.9009 1.19946 68.2733 2.18265 68.357 4.52688C72.4866 4.24714 76.283 4.04596 77.4713 4.04596C81.1264 4.04596 86 5.26434 86 12.5746V25.9769V29.0228V42.425C86 49.7353 81.1264 50.9537 77.4713 50.9537C76.283 50.9537 72.4866 50.7525 68.3571 50.4728C68.2735 52.8173 65.901 53.8005 64.7042 54L16.8391 53.9997C14.0003 53.9997 12.463 50.9376 12.004 49.2725H11.9655C4.65517 49.2725 1.40613 45.0081 1 43.1806V27.1952Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.1952V10.7471C1.40613 8.91949 4.65517 5.87353 11.9655 5.87353M11.9655 5.87353H54.6092C55.8276 6.48272 58.2644 9.8942 58.2644 18.6666V27.8044M11.9655 5.87353C12.3716 4.24902 13.9149 1 16.8391 1L64.7042 1C65.9225 1.20306 68.3593 2.21841 68.3593 4.65517M1 26.7324V43.1806C1.40613 45.0081 4.65517 49.2725 11.9655 49.2725H54.6092C55.8276 48.6633 58.2644 45.2518 58.2644 36.4795V27.3416M55.2184 5.87353C55.8276 5.26434 74.5471 4.04596 77.4713 4.04596C81.1264 4.04596 86 5.26434 86 12.5746V29.0228M55.2184 49.1261C55.8276 49.7353 74.5471 50.9537 77.4713 50.9537C81.1264 50.9537 86 49.7353 86 42.425V25.9769M11.9655 49.1261C12.3716 50.7506 13.9149 53.9997 16.8391 53.9997L64.7042 54C65.9225 53.7969 68.3593 52.7816 68.3593 50.3448",
    stroke: "#435869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBedSeat);
export default __webpack_public_path__ + "static/media/ic-bed-seat.0e00b6ef7c583e64a25f9b8f9f8c51ef.svg";
export { ForwardRef as ReactComponent };